<template>
	<div>
		<van-tabs v-model="returnStatus" @click="changeReturnStatu" sticky>
		  <van-tab title="审核中" :name='1'></van-tab>
		  <van-tab title="审核通过" :name='2'></van-tab>
		  <van-tab title="审核不通过" :name= '3'></van-tab>
		  <van-tab title="已取消" :name= '4'></van-tab>
		</van-tabs>
		<div style="margin-top: 10px;">
			<van-list 
			v-model="loading"
			:finished="finished"
			:finished-text="finishedText"
			@load="loadMore"
			:immediate-check="false"
			>
				<div  v-for="(item,index) in orderList" :key="index" @click='goReturnOrderInfo(item.id)'>
				  <van-row style="padding: 10px 20px;font-size: 12px;">
					<van-col span="18" style="text-align:left;">
						<span>订单编号:</span>
						<span>{{item.out_refund_no}}</span>
					</van-col>
					<van-col span="6" style="text-align: right;">
						<span style="color: orangered;">{{returnStatusText[item.return_status]}}</span>
					</van-col>
				  </van-row>
				  <!-- 商品卡片 -->				  
				  <van-row style="display: flex;padding: 0 20px;align-items: center;">
					  <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
						<van-image
						  width="80"
						  height="80"
						  :src="img"
						/>
					</van-col>
					<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
						<div style="display: flex;align-items: center;text-align: right;">
							<div>
								<div>￥{{item.refund_amount}}</div>
								<div>共{{item.return_quantity}}件</div>
							</div>
							<van-icon name="arrow" style="margin-left: 4px;" />
						</div>																							
					</van-col>	
					</van-row>
					<div style="display: flex;justify-content: space-between;padding: 0 20px;align-items: center;" >
						<div style="font-size: 12px;color: #666;">申请时间 : {{item.create_time*1000 | formonment('YYYY-MM-DD HH:mm:ss')}}</div>
						<van-button v-if="item.return_status == 1" color='#666'  plain  round size="mini" @click.stop='cancelRefundOrder(item.id)'>取消退款</van-button>
					</div>					
				  <van-divider />
				</div>
			</van-list>
		</div>
	</div>
</template>

<script>
	export default{
		name:"returnOrderList",
		data(){
			return{
				returnStatus: 1,				
				page:1,		
				lastPage:1,
				total:0,
				orderList:[],
				returnStatusText:['','审核中','审核通过','审核不通过','已取消'],
				loading: false,
				finished: false,
				finishedText:''
				
			}
		},
		methods:{
			loadMore(){						
				if(this.page<this.last_page){
					this.page++ //分页数+1
					this.getRefundOrderList() 
				}				
			},
			//点击tab页切换状态
			changeReturnStatu(){
				this.page = 1//重置query页码为1
				this.orderList = [] //重置列表数据为空
				this.finishedText=''//重置加载提示文本
				//this.finished=false //重置是否加载完成状态为未加载完成
			
				this.getRefundOrderList()
			},
			//获取退款订单列表
			getRefundOrderList(){
				const toast=this.$toast.loading({
				  message: '',
				  forbidClick: true,
				  loadingType: 'spinner',
				});
				this.request.postURL('/api/RefundOrder/getRefundOrderList',{
					return_status:this.returnStatus,
					page:this.page,
					pageSize:10
				}).then(res=>{
					toast.clear()//关闭加载loading
					this.total=res.data.data.total //给数据条数赋值
					this.last_page=res.data.data.last_page//最后一页
					
					this.orderList.push(...res.data.data.data)//将数据放在列表中	
					this.loading = false //加载状态结束
					this.finished = false
					
					if(this.orderList.length == this.total){
						this.finished=true  //结束加载状态
						if(this.total == 0){
							this.finishedText='暂无数据'
						}else{
							this.finishedText='没有更多了'
						}
					}										
				}).catch(err=>{
					toast.clear()
				})
			},
			//跳转到退款详情页
			goReturnOrderInfo(id){
				this.$router.push({
					 path:'/returnOrderInfo',
					 query:{
						id:id 
					 }
				})
			},
			//用户取消退款
			cancelRefundOrder(id){
				this.$dialog.confirm({
				      message: '您确定要取消退款申请吗？',
				}).then(()=>{					
					const toast =this.$toast.loading({
					  duration: 0, // 持续展示 toast
					  forbidClick: true,
					  message: '',
					});
					this.request.postURL('/api/RefundOrder/cancelRefundOrder',{
						id:id
					}).then(res=>{
						toast.clear()						
						this.$dialog.alert({
						  message: res.data.data.action,
						}).then(() => {						 
						  this.$nextTick(()=>{
							 this.changeReturnStatu()
						  })
						});
					}).catch(err=>{
						toast.clear()
					})
				}).catch(()=>{
					
				})				
			}
		},
		created() {
			this.getRefundOrderList()
		}
	}
</script>

<style>
</style>